import { Form, InputNumber } from "antd";
import "./InputNumber.scss";

const CustomInputNumber = ({
    label,
    name,
    placeholder,
    rules,
    min = 0,
    max,
    formatter,
    isRequired = false,
    parser,
    dependencies,
    formItemStyle,
    className,
    ...rest
}) => {
    return (
        <Form.Item
            label={
                <span>
                    {label}
                    {isRequired && (
                        <span style={{ color: "red", marginLeft: 4 }}>*</span>
                    )}
                </span>
            }
            name={name}
            rules={rules}
            dependencies={dependencies}
            style={formItemStyle}
            className={`custom-input-number-form-item ${className || ""}`.trim()}
        >
            <InputNumber
                changeOnWheel={false}
                placeholder={placeholder}
                min={min}
                max={max}
                className="custom-input-number"
                formatter={(value) =>
                    value
                        ? `${new Intl.NumberFormat('en-IN', {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                        }).format(Number(value))}`
                        : ''
                }
                parser={(value) => value?.replace(/[^\d.]/g, "").slice(0, 15)} // restrict to 15 digits
                onKeyDown={(e) => {
                    const allowedKeys = [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                    ];

                    const isNumber = /^[0-9]$/.test(e.key);

                    if (allowedKeys.includes(e.key)) return;

                    if (!isNumber) {
                        e.preventDefault();
                        return;
                    }
                }}
                onPaste={(e) => {
                    const pasteValue = e.clipboardData.getData("text");

                    if (!/^\d+$/.test(pasteValue)) {
                        e.preventDefault();
                        return;
                    }

                }}
                {...rest}
            />
        </Form.Item>
    );
};

export default CustomInputNumber;
